import React from 'react';
import { HashRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { createAndSaveEvent } from './services/EventLoggingService/EventLoggingService';
import { initAfterLogin } from './services/InitService/InitService';
import CoachPicker from './views/CoachPicker';
import Contact from './views/Contact';
import DevSettings from './views/DevSettings';
import FavoriteOverview from './views/FavoriteOverview';
import HomeScreen from './views/HomeScreen';
import LegalInfo from './views/LegalInfo';
import Module from './views/Module';
import ModuleOverview from './views/ModuleOverview';
import QuickHelp from './views/QuickHelp';
import SelfObservation from './views/SelfObservation/SelfObservation';
import SelfObservationDayOverview from './views/SelfObservation/SelfObservationDayOverview';
import PreSettings from './views/Settings';
import StudyInfo from './views/StudyInfo';
import PrivacyInformation from './views/PrivacyInformation';
import { useAppSelector } from './store/hooks';

const InnerRoutes = () => {
    const path = useLocation().pathname;
    const navigate = useNavigate();
    const moduleState = useAppSelector(state => state.moduleState.currentModuleState);
    const user = useAppSelector(state => state.globalState.user);
    const config = useAppSelector(state => state.globalState.config);

    React.useEffect(() => {
        createAndSaveEvent(user?.code, 'navigation', path);
        const pendingRedirect = localStorage.getItem('pendingRedirect');
        if (pendingRedirect) {
            localStorage.removeItem('pendingRedirect');
            navigate(`/modules/${pendingRedirect}/slots`);
        }
    }, [path]);

    React.useEffect(() => {
        if (moduleState !== undefined && user !== undefined) {
            initAfterLogin(user, moduleState.modifiers, config);
        }
    }, [moduleState, user]);

    return (
        <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="self-observation" element={<SelfObservation />} />
            <Route path="self-observation/:isoDate" element={<SelfObservationDayOverview />} />
            <Route path="modules" element={<ModuleOverview />} />
            <Route path="modules/:moduleId/*" element={<Module />} />
            <Route path="settings" element={<PreSettings />} />
            <Route path="settings/contact" element={<Contact />} />
            <Route path="settings/about" element={<LegalInfo />} />
            <Route path="settings/privacy" element={<PrivacyInformation />} />
            <Route path="settings/dev-settings" element={<DevSettings />} />
            <Route path="favorites/" element={<FavoriteOverview />} />
            <Route path="pick-coach/" element={<CoachPicker />} />
            <Route path="quick-help/" element={<QuickHelp />} />
            <Route path="study-info/" element={<StudyInfo />} />
        </Routes>
    );
};

const Router = () => {
    return (
        <HashRouter>
            <InnerRoutes />
        </HashRouter>
    );
};
export default Router;